export default (() => {

    const eventIdEnums = Object.freeze({
        Mouse: 1,
        Touch: 0,
        Keyboard: -1
    });

    function isMouseEvent (event) {
        return event.pointerId === eventIdEnums.Mouse;
    }

    function isTouchEvent (event) {
        return event.pointerId === eventIdEnums.Touch;
    }

    function isKeyboardEvent (event) {
        return event.pointerId === eventIdEnums.Keyboard;
    }

    return {
        isMouseEvent,
        isTouchEvent,
        isKeyboardEvent
    };

})();